import "./MyDataTable.css";
import React, { useEffect, useState } from "react";
import Category from "../../Model/Category";
import Collection from "../../Model/Collection";
import DataTable, { createTheme } from 'react-data-table-component';
import { useUserActions } from "../../../Connect/_actions";
import Navette from "../../Model/Navette";
import { WebApi } from "../../WebApi/WebApi";
import { authAtom } from "../../../Connect/_state";
import StatusModal from "../Modal/StatusModal";
import SendNewDocModal from "../Modal/SendNewDocModal";
import ExternalDocModal from "../Modal/ExternalDocModal";
import RecepModal from "../Modal/RecepModal";
import downloadLogo from "../../assets/telecharger.png";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import ExpandedDataTable from "./ExpandedDataTable";
import { total_recep } from "./ExpandedDataTable";
import { idCollectionsDownloadingAtom, idNavettesDownloadingAtom, justDownloadedCollectionsAtom, collectionsAtom } from "../../LoadData/LoadData";
import { Tooltip } from "@mui/material";
import Loc from "../../../Loc/Loc";

interface DataTableProps {
    categories: Category[];
    data: any[];
    filter: string;
    expandable: boolean;
    pagination: boolean;
    selectable: boolean;
    background: string;
    title?: string;
    element: string;
    collection?: Collection;
    customStyles: any;
    noDataString?: string;
}

export default function MyDataTable(props: DataTableProps) {
    const [idCollectionsDownloading, setIdCollectionsDownloading] = useRecoilState(idCollectionsDownloadingAtom);
    const [idNavettesDownloading, setIdNavettesDownloading] = useRecoilState(idNavettesDownloadingAtom);
    const setJustDownloadedCollections = useSetRecoilState(justDownloadedCollectionsAtom);
    const justDownloadedCollections = useRecoilValue(justDownloadedCollectionsAtom);
    const [collections, setCollections] = useRecoilState(collectionsAtom);
    const [displayDownload, setDisplayDownload] = useState(false);
    const srows: any[] = [];
    const [selectedRows, setSelectedRows] = useState(srows);
    const webApi = new WebApi();
    const auth = useRecoilValue(authAtom);
    const [isDownloading, setIsDownloading] = useState(false);
    const userActions = useUserActions();
    const isCollection: boolean = (props.element === "Collections");
    const isNavette: boolean = (props.element === "Navettes");
    const isSentDoc: boolean = (props.element === "SentDocs");
    const isExtDoc: boolean = (props.element === "ExternalDocs");
    const download: boolean = props.element === "Collections" || props.element === "Navettes";

    const Download = (item: any) => {
        let element : string = props.element;
        if (isCollection) setIsDownloading(true);
        isCollection ?  setIdCollectionsDownloading([idCollectionsDownloading, item.id].flat()) : setIdNavettesDownloading([idNavettesDownloading, item.id].flat());
        if (props.element === "SentDocs")
            element = "Document";

        webApi.Download(auth.jwtToken, element, item.id, isCollection ? item.reference : item.name)
            .then(response => {
                let newIdList: number[] = [];
                isCollection ? idCollectionsDownloading.forEach(id => { if (id !== item.id) newIdList.push(id)}) : idNavettesDownloading.forEach(id => { if (id !== item.id) newIdList.push(id)})
                isCollection ? setIdCollectionsDownloading(newIdList) : setIdNavettesDownloading(newIdList);
                if (isCollection) setIsDownloading(false);
                if (isCollection) setJustDownloadedCollections([justDownloadedCollections, item].flat());
                if (isCollection) {
                    setCollections(
                        collections.map((collection: Collection) => {
                            if (item.id === collection.id) {
                                let newCollection: Collection = JSON.parse(JSON.stringify(collection)); // je fais ça car "collection" est en read-only, je ne peux donc pas le modifier
                                newCollection.dateDownload = response;
                                return (newCollection);
                            }
                            return (collection);
                        })
                    )
                }
            })
            .catch(error => {
                console.log(error);
                userActions.logout();
            })
    }

    const DefineColorTotalRecep = (navettes: Navette[]) => {
        let nbr_recep: number = 0;
        navettes.forEach((nav) => {
            if (nav.retourClient !== "") {
                nbr_recep++;
            }
        })
        if (nbr_recep === navettes.length) {
            return ("rgb(1, 170, 1)");
        }
        if (nbr_recep === 0) {
            return ("red");
        }
        return ("orange");
    }

    const isItemDownloading = (id: number) => {
        let isItemDownloading: boolean = false;
        if (isNavette) {
            idNavettesDownloading.forEach((navId: number) => {
                if (navId === id) {
                    isItemDownloading = true;
                }
            })
            return isItemDownloading;
        }
        idCollectionsDownloading.forEach((colId: number) => {
            if (colId === id) {
                isItemDownloading = true;
            }
        })
        return isItemDownloading;
    }

    const item_for_download = (item: any) => {
        let newItem: any = {};
        newItem.id = parseInt(item.id);
        isCollection ? newItem.reference = item.reference : newItem.name = item.name;
        return (newItem);
    }

    const isThereOneNavetteRecep = (navettes: Navette[]) => {
        let recep: boolean = false;
    
        if (navettes.length === 0) {
            return false;
        }
        navettes.forEach((nav) => {
            if (nav.retourClient !== "") {
                recep = true;
            }
        })
        return recep;
    }

    const columns = (
        [
            download ? { // Ajouter bouton Télécharger
                cell: (item: any) =>
                    <button className="download" onClick={() => Download(item_for_download(item))} disabled={isDownloading}>
                        {
                            isItemDownloading(parseInt(item.id)) ?
                                <div className="enCours">{Loc.trad().MyDataTableProgress}<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></div> :
                                <img src={downloadLogo} alt="download" style={{ height: "25px" }}></img>
                            // <div>Télécharger</div>
                        }
                    </button>,
                button: true
            } : [],
            isSentDoc ? { // Ajouter bouton Télécharger
                cell: (item: any) =>
                    <button className="download" onClick={() => Download(item_for_download(item))} disabled={isDownloading}>
                        {
                            isItemDownloading(parseInt(item.id)) ?
                                <div className="enCours">{Loc.trad().MyDataTableProgress}<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></div> :
                                <img src={downloadLogo} alt="download" style={{ height: "25px" }}></img>
                            // <div>Télécharger</div>
                        }
                    </button>,
                button: true
            } : [],
            props.categories.map((category) => { // définir les colonnes du DataTable
                return (
                    {
                        name: category.label,
                        selector: (row: any) => <Tooltip title={row[category.field]}><div>{row[category.field]}</div></Tooltip>
                    }
                )
            }),
            isCollection || isNavette || isExtDoc ? { // Ajouter bouton lié à la Réception (Réceptionner, Approuvé, etc...) si Collection, Navette ou DocExterne
                cell: (item: any) => {
                    if (isCollection) {
                        if (isThereOneNavetteRecep(item.navettes) /* || item.allRecep */) {
                            return (<button className="btn btn-secondary btn-sm" style={{ padding: "4px" }} disabled>{Loc.trad().MyDataTableReceived}</button>)
                        }
                        return (<RecepModal isCollection={isCollection} item={item}></RecepModal>)
                    }
                    if (isNavette) {
                        if (item.retourClient !== "") {
                            return (<StatusModal navette={item}></StatusModal>)
                        }
                        return (<RecepModal isCollection={isCollection} item={item} collection={props.collection}></RecepModal>)
                    }
                    if (isExtDoc) {
                        if (item.state === "") {
                            return (<ExternalDocModal externalDoc={item} recep={true}></ExternalDocModal>)
                        }
                        return (<ExternalDocModal externalDoc={item} recep={false}></ExternalDocModal>)
                    }
                }
            } : isSentDoc ? { // Ajouter le bouton Modifier si on est dans Envoi de documents
                cell: (item: any) =>
                <SendNewDocModal
                    modifyDoc={true}
                    item={item}
                ></SendNewDocModal>
                ,
                button: true
            } : [],
            isCollection ? { // Afficher total documents réceptionnés si c'est une collection
                cell: (item: any) => {
                    return (
                        <div className="totalrecep" style={{color: DefineColorTotalRecep(item.navettes)}}>{total_recep(item.navettes)}</div>
                    )
                },
                button: true
            } : []
        ].flat()
    );

    const [data, setData] = useState(props.data);

    useEffect(() => {
        setData(props.data
            .filter((item) => {
                if (!isCollection && !isSentDoc) { // ajout provisoire
                    return true;
                }
                let fields: string[] = props.categories.map(category => { return category.field })
                let keys: string[] = Object.keys(item);
                let values: string[] = Object.values(item);
                let include: boolean = false;
                keys.forEach((key) => {
                    if (fields.includes(key)) {
                        values.forEach(value => {
                            if (value !== null && value.toString().toLowerCase().includes(props.filter.toLowerCase())) {
                                include = true;
                            }
                        })
                    }
                })
                return include;
            })
        )
    }, [setData, props.data, props.filter, props.categories, isCollection, isSentDoc, isExtDoc])                                                                                                                              

    const paginationComponentOptions = {
        noRowsPerPage: true,
        rangeSeparatorText: Loc.trad().MyDataTableSeparator,
        selectAllRowsItem: false
    };

    const ExpandedComponent = ({ data } : any) => (
        <ExpandedDataTable collection={data}></ExpandedDataTable>
    );

    createTheme('customBackground', {
        background: {
            default: props.background,
        },
        button: {
            focus: "#ececec",
            hover: "#ececec"
        },
        divider: {
            default: '#af007c',
        }
    });

    function actionsMemo() {
        const DownloadSelected = () => {
            let length: number = selectedRows.length;
            setIsDownloading(true);
            selectedRows.forEach((item: Collection, index) => {
                webApi.Download(auth.jwtToken, props.element, item.id, item.reference)
                .then(() => {
                    if (index === length - 1) {
                        setJustDownloadedCollections([justDownloadedCollections, selectedRows].flat());
                        setIsDownloading(false);
                    }
                })
                .catch(error => {
                    console.log(error);
                    userActions.logout();
                })
            })
        }
        return (
            displayDownload && <button className="btn btn-outline-dark" style={{ zIndex: 2 }} onClick={DownloadSelected} disabled={isDownloading}>
                {
                    isDownloading ? <div>{Loc.trad().MyDataTableDownloading}<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></div> :
                    <div>{Loc.trad().MyDataTableDownload}</div>
                }
            </button>
        )
    }

    const handleRowSelected = (selected: any) => {
        if (selected.selectedCount > 0) {
            setDisplayDownload(true);
        }
        else {
            setDisplayDownload(false);
        }
        setSelectedRows(selected.selectedRows);
    }

    const NoDataComponent = () => (
        <div style={{ height: "50px" }}>
            {props.noDataString || Loc.trad().MyDataTableNoData}
            {props.noDataString && <span className="spinner-border spinner-border-sm mr-1"></span>}
        </div>
    )

    return (
        <DataTable
            title={props.title}
            columns={columns}
            data={data}
            noDataComponent={<NoDataComponent />}
            expandableRows={props.expandable}
            expandOnRowClicked
            expandableRowsComponent={ExpandedComponent}
            pagination={props.pagination}
            paginationComponentOptions={paginationComponentOptions}
            theme="customBackground"
            customStyles={props.customStyles}
            contextMessage={{singular: Loc.trad().MyDataTableSelected, plural: Loc.trad().MyDataTableSelectedPlural}}
            selectableRows={props.selectable}
            onSelectedRowsChange={handleRowSelected}
            actions={actionsMemo()}
        />
    );
}